import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useAuthStore = create(
  persist(
    (set) => ({
      // State
      token: null,
      refreshToken: null,
      user: null,
      status: "idle", // "idle" | "loading" | "authenticated" | "unauthenticated"
      error: null,
      loginAttempts: 0,
      lastLoginAttempt: null,
      /** Suppresses SDK token refresh while logout teardown runs (not persisted). */
      isLoggingOut: false,

      // Pure Actions
      setLoading: () => set({ status: "loading", error: null }),

      setLoggingOut: (isLoggingOut) => set({ isLoggingOut: Boolean(isLoggingOut) }),

      setAuthenticated: (token, refreshToken, user) => set({
        token,
        refreshToken,
        user,
        status: "authenticated",
        error: null,
        loginAttempts: 0,
        lastLoginAttempt: null,
        isLoggingOut: false,
      }),

      setUser: (user) => set({
        user,
        status: "authenticated",
        error: null
      }),

      setUnauthenticated: (error = null) => set({
        token: null,
        refreshToken: null,
        user: null,
        status: "unauthenticated",
        error
      }),

      incrementLoginAttempts: () => set((state) => ({
        loginAttempts: state.loginAttempts + 1,
        lastLoginAttempt: Date.now()
      })),

      resetRateLimit: () => set({ loginAttempts: 0, lastLoginAttempt: null }),

      clearError: () => set({ error: null }),
    }),
    {
      name: "auth-storage",
      partialize: (state) => ({
        token: state.token,
        refreshToken: state.refreshToken,
        user: state.user,
        loginAttempts: state.loginAttempts,
        lastLoginAttempt: state.lastLoginAttempt
      }),
    }
  )
);
